module.exports = __webpack_public_path__ + "static/equipment-garbage-truck-31eb81a4c2210dcb36eade2398f22532.jpg";